import { useContextStore } from '@/stores/context'
import { useManagedAccountStore } from '@/stores/managed-account'

/**
 * `true` when the account currently being administered is invoiced with a Brazilian
 * NFe — the managed account while managing one, the logged-in account otherwise.
 * That mirrors which account the /settings admin endpoints act on.
 *
 * Gates the tax-data screen, which exists only to collect what the NFe needs: a
 * GLOBAL-tenant account is never issued one, so it has no tax data to fill in.
 */
export function useShouldGenerateNfe(): boolean {
  const isManaging = useManagedAccountStore((state) => state.isManaging)
  const managedShouldGenerateNfe = useManagedAccountStore(
    (state) => state.shouldGenerateNfe,
  )
  const ownShouldGenerateNfe = useContextStore(
    (state) => state.userAccountContext?.accountInformation.shouldGenerateNfe,
  )

  return isManaging ? managedShouldGenerateNfe : ownShouldGenerateNfe === true
}
